import { QueryClient } from "@tanstack/react-query";

import {
  getQuoteRequestLineQueryData,
  setQuoteRequestLineQueryData,
} from "#modules/quoteRequestLines/infra/quoteRequestLine.query";

export type PreviousQuoteRequestLineIndexes = Map<string, number>;

export const applyReorderToQuoteRequestLinesCache = ({
  queryClient,
  orderedIds,
}: {
  queryClient: QueryClient;
  orderedIds: string[];
}): PreviousQuoteRequestLineIndexes => {
  const previousIndexes: PreviousQuoteRequestLineIndexes = new Map();

  orderedIds.forEach((id, index) => {
    const line = getQuoteRequestLineQueryData(queryClient, id);

    if (!line || line.index === index) {
      return;
    }

    previousIndexes.set(id, line.index);
    setQuoteRequestLineQueryData(queryClient, id, { ...line, index });
  });

  return previousIndexes;
};

export const revertReorderInQuoteRequestLinesCache = ({
  queryClient,
  previousIndexes,
}: {
  queryClient: QueryClient;
  previousIndexes: PreviousQuoteRequestLineIndexes;
}) => {
  previousIndexes.forEach((index, id) => {
    const line = getQuoteRequestLineQueryData(queryClient, id);

    if (!line) {
      return;
    }

    setQuoteRequestLineQueryData(queryClient, id, { ...line, index });
  });
};
